import { render, staticRenderFns } from "./MenuSuperadmin.vue?vue&type=template&id=4e29a560&"
import script from "./MenuSuperadmin.vue?vue&type=script&lang=js&"
export * from "./MenuSuperadmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports